import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    CardTitle,
    CardSubtitle,
    Label,
    Input,
    Container,
    Form,
    FormFeedback,
    UncontrolledAlert,
    Spinner,
    FormGroup
} from "reactstrap";
import { get, put, del } from "../../../Services/RestAPIService";
import { useParams, useNavigate } from 'react-router-dom';
import Select from "react-select";
import makeAnimated from "react-select/animated";
import AlertModal from "../../../components/AlertModal";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useTranslation } from 'react-i18next';
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const EditVideos = () => {
    const animatedComponents = makeAnimated();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingdel, setIsLoadingdel] = useState(false);
    const [isAlertModal, setIsAlertModal] = useState(false);
    const [exerciseImage, setExerciseImage] = useState(null);
    const [activitiesSelected, setActivitiesSelected] = useState([]);
    const [occupationsSelected, setOccupationsSelected] = useState([]);
    const [videoLink, setVideoLink] = useState('');
    const [videoPlatform, setVideoPlatform] = useState('YouTube');
    const [exerciseWhileStanding, setExerciseWhileStanding] = useState(false);
    const [exerciseWhileLying, setExerciseWhileLying] = useState(false);
    const [difficulty, setDifficulty] = useState('easy');

    const [frequency, setFrequency] = useState('Daily');
    const { subid, exeid, id } = useParams();
    const navigate = useNavigate();
    const [alert, setAlert] = useState({
        color: "",
        message: "",
        visible: false
    });
    const [activities, setActivities] = useState([
        { value: 'Walking', label: t('Walking') },
        { value: 'Running', label: t('Running') },
        { value: 'Swimming', label: t('Swimming') },
        { value: 'Cycling', label: t('Cycling') },
        { value: 'Yoga', label: t('Yoga') },
        { value: 'Gym', label: t('Gym') },
        { value: 'Dancing', label: t('Dancing') },
        { value: 'Hiking', label: t('Hiking') }
    ]);
    const [occupations, setOccupations] = useState([
        { value: 'Construction', label: t('Construction (e.g., bricklayer, labourer)') },
        { value: 'Sports', label: t('Sports (e.g., coach, professional athlete)') },
        { value: 'Services and Hospitality', label: t('Services and Hospitality (e.g., waiter, chef)') },
        { value: 'Office/Remote Work', label: t('Office/Remote Work (e.g., programmer, accountant)') },
        { value: 'Education', label: t('Education (e.g., teacher, librarian)') }
    ]);
    const [dataOriginal, setDataOriginal] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [subcategoriesMap, setSubcategoriesMap] = useState({});
    const [selectedSubcategories, setSelectedSubcategories] = useState({});
    const [exercisesMap, setExercisesMap] = useState({});
    const [selectedExercises, setSelectedExercises] = useState({});

    const getUsersData = async (data) => {
        try {
            const usersData = await get(`category/categories/?parent_id_isnull=true`);
            if (usersData) {
                let formattedData = usersData.results.map((category) => ({
                    label: category.name,
                    value: category.id.toString(),
                }));
                setDataOriginal(formattedData);
                // if (subid && subid !== "id") {
                //     const selected = formattedData.filter(cat => cat.value === subid);
                //     setSelectedCategories(selected);
                //     selected.forEach(cat => fetchSubcategories(cat.value,data));
                // }

                const matchedCategories = formattedData.filter(fdItem =>
                    data?.parent_categories?.some(parentCat => parseInt(parentCat.id) === parseInt(fdItem.value))
                  );
                  
                  if (matchedCategories.length > 0) {
                    setSelectedCategories(matchedCategories);
                    matchedCategories.forEach(cat => fetchSubcategories(cat.value, data));
                  }


            } else {
                console.error('No data found in the response.');
            }
        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    };

    const fetchSubcategories = async (parentId,data) => {

        console.log(parentId,data,"parentId")
        try {
            const SubcatData = await get(`category/categories/?parent_id=${parentId}`);

            console.log(SubcatData,"SubcatData")
            if (SubcatData) {
                let formattedDataSubCat = SubcatData.results.map((category) => ({
                    label: category.name,
                    value: category.id.toString(),
                }));
                setSubcategoriesMap(prev => ({
                    ...prev,
                    [parentId]: formattedDataSubCat
                }));
                // if (exeid && exeid !== "id") {
                //     const selected = formattedDataSubCat.filter(subcat => subcat.value === exeid);
                //     setSelectedSubcategories(prev => ({
                //         ...prev,
                //         [parentId]: selected
                //     }));
                //     selected.forEach(subcat => fetchExercises(subcat.value,data));
                // }

                const matchedSubcats = formattedDataSubCat.filter(subcat =>
                    data?.categories?.some(cat => cat.id.toString() === subcat.value)
                  );
                  
                  if (matchedSubcats.length > 0) {
                    setSelectedSubcategories(prev => ({
                      ...prev,
                      [parentId]: matchedSubcats
                    }));
                  
                    matchedSubcats.forEach(subcat => fetchExercises(subcat.value, data));
                  }

            } else {
                console.error('No data found in the response.');
            }
        } catch (error) {
            console.error('Error fetching subcategory data:', error);
        }
    };

    const fetchExercises = async (subcategoryId,data) => {
        console.log(subcategoryId,"subcategoryId")

        try {
            const ExerciseData = await get(`exercise/exercises/?categories=${subcategoryId}&page_size=1000`);

            console.log(ExerciseData,"ExerciseData")
            if (ExerciseData) {
                let formattedDataExercise = ExerciseData.results.map((category) => ({
                    label: category.exercise_name,
                    value: category.id.toString(),
                }));
                setExercisesMap(prev => ({
                    ...prev,
                    [subcategoryId]: formattedDataExercise
                }));
                // if (id && id !== "id") {
                //     const selected = formattedDataExercise.filter(ex => ex.value === id);
                //     setSelectedExercises(prev => ({
                //         ...prev,
                //         [subcategoryId]: selected
                //     }));
                // }


                const matchedExercise = formattedDataExercise?.filter(exercise =>
                    data?.exercises?.some(item => item?.id?.toString() === exercise?.value)
                  );
                  
                  if (matchedExercise?.length > 0) {
                    setSelectedExercises(prev => ({
                      ...prev,
                      [subcategoryId]: matchedExercise
                    }));
                  
                  
                    // matchedexercise.forEach(subcat => fetchExercises(subcat.value, data));
                  }


            } else {
                console.error('No data found in the response.');
            }
        } catch (error) {
            console.error('Error fetching exercise data:', error);
        }
    };

    const fetchVideoData = async () => {
        try {
            const response = await get(`exercise/exercises-videos/${id}`);
            console.log(response,"GGGAA")

            // fetchExercises(response.exercise_id?.id)
            getUsersData(response)

            const videoData = response;
            validation.setValues({
                title: videoData.title || '',
                description: videoData.description || '',
                video: videoData.video || '',
                activities: videoData.activities.map(activity => activities.find(a => a.value === activity) || { value: activity, label: activity }),
                frequency: videoData.frequency || 'Daily',
                occupation: videoData.occupation.map(occupation => occupations.find(o => o.value === occupation) || { value: occupation, label: occupation }),
                exercise_while_standing: videoData.exercise_while_standing || false,
                exercise_while_lying: videoData.exercise_while_lying || false,
                exerciseData: videoData.exercise_ids || []
            });
            setVideoLink(videoData.video || '');
            setVideoPlatform(videoData.video.includes('youtube.com') || videoData.video.includes('youtu.be') ? 'YouTube' : 'Vimeo');
            setExerciseWhileStanding(videoData.exercise_while_standing || false);
            setExerciseWhileLying(videoData.exercise_while_lying || false);
            setFrequency(videoData.frequency || 'Daily');
            setActivitiesSelected(videoData.activities.map(activity => activities.find(a => a.value === activity) || { value: activity, label: activity }));
            setOccupationsSelected(videoData.occupation.map(occupation => occupations.find(o => o.value === occupation) || { value: occupation, label: occupation }));
            setDifficulty(videoData.difficulty)

            // Prefill categories, subcategories, and exercises
            // if (videoData.parent_categories && videoData.parent_categories.length > 0) {
            //     const exerciseDetails = await Promise.all(
            //         videoData.exercise_ids.map(exId => get(`exercise/exercises/${exId}`))
            //     );
            //     const categoryIds = [...new Set(exerciseDetails.map(ex => ex.category_id))];
            //     const parentCategoryIds = await Promise.all(
            //         categoryIds.map(catId => get(`category/categories/${catId}`).then(cat => cat.parent_id))
            //     ).then(ids => [...new Set(ids.filter(id => id))]);

            //     // Set parent categories
            //     const parentCategories = dataOriginal.filter(cat => parentCategoryIds.includes(Number(cat.value)));
            //     setSelectedCategories(parentCategories);
            //     parentCategories.forEach(cat => fetchSubcategories(cat.value));

            //     // Set subcategories and exercises after fetching
            //     setTimeout(() => {
            //         const subcatMap = {};
            //         const exMap = {};
            //         exerciseDetails.forEach(ex => {
            //             const subcatId = ex.category_id.toString();
            //             const parentId = parentCategoryIds.find(pid => subcategoriesMap[pid]?.find(sc => sc.value === subcatId))?.toString();
            //             if (parentId) {
            //                 subcatMap[parentId] = subcatMap[parentId] || [];
            //                 const subcat = subcategoriesMap[parentId]?.find(sc => sc.value === subcatId);
            //                 if (subcat && !subcatMap[parentId].find(sc => sc.value === subcatId)) {
            //                     subcatMap[parentId].push(subcat);
            //                 }
            //                 exMap[subcatId] = exMap[subcatId] || [];
            //                 exMap[subcatId].push({ value: ex.id.toString(), label: ex.exercise_name });
            //             }
            //         });
            //         setSelectedSubcategories(subcatMap);
            //         setSelectedExercises(exMap);
            //     }, 1000); // Delay to ensure subcategories are fetched
            // }
        } catch (error) {
            console.error('Error fetching video data:', error);
            setAlert({
                color: "danger",
                visible: true,
                message: t("Failed to load video data.")
            });
        }
    };

    const handleParentChange = (selected) => {
        setSelectedCategories(selected);
        selected.forEach((cat) => {
            if (!subcategoriesMap[cat.value]) {
                fetchSubcategories(cat.value);
            }
        });
        const updatedSubcategories = {};
        const updatedExercises = {};
        selected.forEach((cat) => {
            if (selectedSubcategories[cat.value]) {
                updatedSubcategories[cat.value] = selectedSubcategories[cat.value];
                selectedSubcategories[cat.value].forEach((subcat) => {
                    if (selectedExercises[subcat.value]) {
                        updatedExercises[subcat.value] = selectedExercises[subcat.value];
                    }
                });
            }
        });
        setSelectedSubcategories(updatedSubcategories);
        setSelectedExercises(updatedExercises);
    };

    const handleSubcategoryChange = (parentId, selected) => {
        console.log("RUNN")
        setSelectedSubcategories(prev => ({
            ...prev,
            [parentId]: selected
        }));
        selected.forEach((subcat) => {
            if (!exercisesMap[subcat.value]) {
                fetchExercises(subcat.value,null);
            }
        });
        const updatedExercises = {};
        selected.forEach((subcat) => {
            if (selectedExercises[subcat.value]) {
                updatedExercises[subcat.value] = selectedExercises[subcat.value];
            }
        });
        setSelectedExercises(updatedExercises);
    };

    useEffect(() => {
        // getUsersData(null);
        fetchVideoData();
    }, [dataOriginal.length]);

    const validation = useFormik({
        initialValues: {
            title: '',
            description: '',
            video: videoLink,
            activities: [],
            frequency: frequency,
            occupation: [],
            exercise_while_standing: exerciseWhileStanding,
            exercise_while_lying: exerciseWhileLying,
            exerciseData: []
        },
        validationSchema: Yup.object({
            title: Yup.string().required(t("Please Enter Video Title")),
            description: Yup.string().required(t("Please Enter Description")),
            video: Yup.string().url(t("Invalid URL format")).required(t("Please Enter Video Link")),
            activities: Yup.array().min(1, t("Please select at least one activity")),
            frequency: Yup.string().required(t("Please select frequency")),
            occupation: Yup.array().min(1, t("Please select at least one occupation")),
            exercise_while_standing: Yup.boolean().required(t("Please specify if exercises while standing")),
            exercise_while_lying: Yup.boolean().required(t("Please specify if exercises while lying")),
            // exerciseData: Yup.array().min(1, t("Please select at least one exercise"))
        }),
        onSubmit: async (values, { resetForm }) => {
            setIsLoading(true);
            // const exerciseIds = Object.values(selectedExercises).flat().map(item => Number(item.value));
            // const uniqueExerciseIds = [...new Set(exerciseIds)];

            const exerciseIds = Object.values(selectedExercises).flat().map(item => Number(String(item.value).trim())).filter(val => !isNaN(val)); // Removes NaN values
            const uniqueExerciseIds = [...new Set(exerciseIds)];

            const Data = {
                "title": values.title,
                "description": values.description,
                "video": videoLink,
                "activities": values.activities.map(activity => activity.value),
                "frequency": values.frequency,
                "occupation": values.occupation.map(occupation => occupation.value),
                "exercise_while_standing": values.exercise_while_standing,
                "exercise_while_lying": values.exercise_while_lying,
                "exercise_id": uniqueExerciseIds[0] || Number(id),
                "exercises": uniqueExerciseIds.length > 0 ? uniqueExerciseIds : [Number(id)],
                "difficulty":difficulty
            };
            console.log(Data,"Data")
            try {
                const response = await put(`exercise/exercises-videos/${id}/`, Data, {
                    headers: { 'Content-Type': 'application/json' },
                    validateStatus: false
                });
                if (response.status <= 399) {
                    setAlert({
                        color: "success",
                        visible: true,
                        message: t("Video updated successfully!")
                    });
                    setTimeout(() => {
                        navigate(`/category/videos/${selectedSubcategories[Object.keys(selectedSubcategories)[0]]?.[0]?.value || subid || 'id'}/${exerciseIds[0] || exeid || 'id'}/${exerciseIds[0] || id}`);
                    }, 1500);
                } else {
                    let errorMessage = t("An error occurred while updating video.");
                    for (const key in response.data) {
                        if (Array.isArray(response.data[key]) && response.data[key].length > 0) {
                            errorMessage = `${key}: ${response.data[key][0]}`;
                            break;
                        }
                    }
                    setAlert({
                        color: "danger",
                        visible: true,
                        message: errorMessage
                    });
                }
            } catch (error) {
                console.error('Error updating video:', error);
                setAlert({
                    color: "danger",
                    visible: true,
                    message: t("An error occurred while updating video.")
                });
            } finally {
                setIsLoading(false);
                setTimeout(() => {
                    setAlert({ visible: false });
                }, 3000);
            }
        }
    });

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setExerciseImage(base64String);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleVideoLinkChange = (event) => {
        setVideoLink(event.target.value);
        validation.setFieldValue('video', event.target.value);
    };

    const handleFrequencyChange = (event) => {
        setFrequency(event.target.value);
        validation.setFieldValue('frequency', event.target.value);
    };

    const handleExerciseWhileStandingChange = (event) => {
        const value = event.target.value === 'Yes';
        setExerciseWhileStanding(value);
        validation.setFieldValue('exercise_while_standing', value);
    };

    const handleExerciseWhileLyingChange = (event) => {
        const value = event.target.value === 'Yes';
        setExerciseWhileLying(value);
        validation.setFieldValue('exercise_while_lying', value);
    };

    const handleDiff = (event) => {
        console.log(event.target.value,"HGGGGG")
        // const value = event.target.value === 'Yes';
        setDifficulty(event.target.value);
        validation.setFieldValue('exercise_while_lying', value);
    };

    const getVideoEmbedUrl = (platform, link) => {
        switch (platform) {
            case 'YouTube':
                return `https://www.youtube.com/embed/${encodeURIComponent(getYoutubeVideoId(link))}`;
            case 'Vimeo':
                return `https://player.vimeo.com/video/${getVimeoVideoId(link)}`;
            default:
                return '';
        }
    };

    const getYoutubeVideoId = (link) => {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/?\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = link.match(regex);
        return match ? match[1] : '';
    };

    const getVimeoVideoId = (link) => {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)([0-9]+)/;
        const match = link.match(regex);
        return match ? match[1] : '';
    };

    const handleDeleteExercise = async () => {
        try {
            setIsLoadingdel(true);
            const response = await del(`exercise/exercises-videos/${id}/`);
            if (response.status <= 400) {
                setAlert({
                    color: "success",
                    visible: true,
                    message: t("Video deleted successfully!")
                });
                setTimeout(() => {
                    navigate(`/category/videos/${selectedSubcategories[Object.keys(selectedSubcategories)[0]]?.[0]?.value || subid || 'id'}/${Object.values(selectedExercises).flat()[0]?.value || exeid || 'id'}`);
                }, 1500);
            } else {
                setAlert({
                    color: "danger",
                    visible: true,
                    message: t("An error occurred while deleting the video.")
                });
            }
        } catch (error) {
            console.error('Error deleting video:', error);
            setAlert({
                color: "danger",
                visible: true,
                message: t("An error occurred while deleting the video.")
            });
        } finally {
            setTimeout(() => {
                setAlert({ visible: false });
            }, 3000);
            setIsAlertModal(false);
            setIsLoadingdel(false);
        }
    };

    return (
        <React.Fragment>
            {alert.visible && <UncontrolledAlert className="Alert_Additions_Log" color={alert.color}>{alert.message}</UncontrolledAlert>}
            {isAlertModal && (
                <AlertModal
                    selection={(e) => { e === true ? handleDeleteExercise() : setIsAlertModal(false) }}
                    Display={null}
                />
            )}
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs maintitle={t("Home")} title={t("Exercise Videos")} titleLink={`/category/videos/${selectedSubcategories[Object.keys(selectedSubcategories)[0]]?.[0]?.value || subid || 'id'}/${Object.values(selectedExercises).flat()[0]?.value || exeid || 'id'}/${id}`} breadcrumbItem={t("Edit Videos")} />
                    <Row>
                        <Col lg={6}>
                            <Card>
                                <CardBody>
                                    <CardTitle>{t("Edit Video Data")}</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        {t("Edit details below to update the exercise video.")}
                                    </CardSubtitle>
                                    <Form onSubmit={validation.handleSubmit}>
                                        <FormGroup className="mb-3">
                                            <Label className="form-label">{t('Select Parent Category')}</Label>
                                            <Select
                                                isMulti
                                                value={selectedCategories}
                                                name="parentCategories"
                                                onChange={handleParentChange}
                                                onBlur={validation.handleBlur}
                                                options={dataOriginal}
                                                classNamePrefix="select2-selection"
                                            />
                                            {validation.touched.exerciseData && validation.errors.exerciseData && (
                                                <FormFeedback type="invalid">{validation.errors.exerciseData}</FormFeedback>
                                            )}
                                        </FormGroup>
                                        {selectedCategories.map((cat) => (
                                            <React.Fragment key={cat.value}>
                                                <FormGroup className="mb-3">
                                                    <Label>
                                                        {t("Select Body Parts for")} <strong>{cat.label}</strong>
                                                    </Label>
                                                    <Select
                                                        isMulti
                                                        name={`bodyParts-${cat.value}`}
                                                        options={subcategoriesMap[cat.value] || []}
                                                        value={selectedSubcategories[cat.value] || []}
                                                        onChange={(selected) => handleSubcategoryChange(cat.value, selected)}
                                                        classNamePrefix="select2-selection"
                                                    />
                                                </FormGroup>
                                                {(selectedSubcategories[cat.value] || []).map((subcat) => (
                                                    <FormGroup key={subcat.value} className="mb-3">
                                                        <Label style={{color:"#000000"}}>
                                                            {t("Select Exercises for")} <strong style={{color:"#ae5700"}}>{subcat.label}</strong>
                                                        </Label>
                                                        <Select
                                                            isMulti
                                                            name={`exercises-${subcat.value}`}
                                                            options={exercisesMap[subcat.value] || []}
                                                            value={selectedExercises[subcat.value] || []}
                                                            onChange={(selected) => setSelectedExercises(prev => ({
                                                                ...prev,
                                                                [subcat.value]: selected
                                                            }))}
                                                            classNamePrefix="select2-selection"
                                                        />
                                                    </FormGroup>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                        <div className="mb-3">
                                            <Label className="form-label">{t("Video Title")}</Label>
                                            <Input
                                                name="title"
                                                type="text"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.title || ""}
                                                invalid={validation.touched.title && validation.errors.title}
                                            />
                                            {validation.touched.title && validation.errors.title && (
                                                <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <Label className="form-label">{t("Description")}</Label>
                                            <Input
                                                type="textarea"
                                                name="description"
                                                rows="5"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.description || ""}
                                                invalid={validation.touched.description && validation.errors.description}
                                            />
                                            {validation.touched.description && validation.errors.description && (
                                                <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                                            )}
                                        </div>
                                        <Row>
                                            <Col>
                                                <FormGroup className="mb-3 templating-select select2-container">
                                                    <Label className="control-label">{t("Select Activities")}</Label>
                                                    <Select
                                                        value={activitiesSelected}
                                                        isMulti={true}
                                                        onChange={(selectedOptions) => {
                                                            setActivitiesSelected(selectedOptions);
                                                            validation.setFieldValue('activities', selectedOptions);
                                                        }}
                                                        options={activities}
                                                        classNamePrefix="select2-selection"
                                                        closeMenuOnSelect={false}
                                                        components={animatedComponents}
                                                    />
                                                    {validation.touched.activities && validation.errors.activities && (
                                                        <FormFeedback type="invalid" className="d-block">{validation.errors.activities}</FormFeedback>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Label className="form-label">{t("Select Frequency")}</Label>
                                                    <Input
                                                        type="select"
                                                        name="frequency"
                                                        onChange={handleFrequencyChange}
                                                        value={frequency}
                                                        invalid={validation.touched.frequency && validation.errors.frequency}
                                                    >
                                                        <option value="Daily">{t("Daily")}</option>
                                                        <option value="Occasionally">{t("Occasionally")}</option>
                                                        <option value="Rarely">{t("Rarely")}</option>
                                                        <option value="Never">{t("Never")}</option>
                                                    </Input>
                                                    {validation.touched.frequency && validation.errors.frequency && (
                                                        <FormFeedback type="invalid">{validation.errors.frequency}</FormFeedback>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                        <FormGroup className="mb-3 templating-select select2-container">
                                            <Label className="control-label">{t("Select Occupations")}</Label>
                                            <Select
                                                value={occupationsSelected}
                                                isMulti={true}
                                                onChange={(selectedOptions) => {
                                                    setOccupationsSelected(selectedOptions);
                                                    validation.setFieldValue('occupation', selectedOptions);
                                                }}
                                                options={occupations}
                                                classNamePrefix="select2-selection"
                                                closeMenuOnSelect={false}
                                                components={animatedComponents}
                                            />
                                            {validation.touched.occupation && validation.errors.occupation && (
                                                <FormFeedback type="invalid" className="d-block">{validation.errors.occupation}</FormFeedback>
                                            )}
                                        </FormGroup>
                                        <Row>
                                            <Col>
                                                <div className="mb-3">
                                                    <Label className="form-label">{t("Video of Exercises while standing")}</Label>
                                                    <Input
                                                        type="select"
                                                        name="exercise_while_standing"
                                                        onChange={handleExerciseWhileStandingChange}
                                                        value={exerciseWhileStanding ? "Yes" : "No"}
                                                        invalid={validation.touched.exercise_while_standing && validation.errors.exercise_while_standing}
                                                    >
                                                        <option value="Yes">{t("Yes")}</option>
                                                        <option value="No">{t("No")}</option>
                                                    </Input>
                                                    {validation.touched.exercise_while_standing && validation.errors.exercise_while_standing && (
                                                        <FormFeedback type="invalid">{validation.errors.exercise_while_standing}</FormFeedback>
                                                    )}
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="mb-3">
                                                    <Label className="form-label">{t("Video of Exercises while lying down")}</Label>
                                                    <Input
                                                        type="select"
                                                        name="exercise_while_lying"
                                                        onChange={handleExerciseWhileLyingChange}
                                                        value={exerciseWhileLying ? "Yes" : "No"}
                                                        invalid={validation.touched.exercise_while_lying && validation.errors.exercise_while_lying}
                                                    >
                                                        <option value="Yes">{t("Yes")}</option>
                                                        <option value="No">{t("No")}</option>
                                                    </Input>
                                                    {validation.touched.exercise_while_lying && validation.errors.exercise_while_lying && (
                                                        <FormFeedback type="invalid">{validation.errors.exercise_while_lying}</FormFeedback>
                                                    )}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                        <Col>
                                        {videoPlatform && (
                                            <div className="mb-3">
                                                <Label className="form-label">{t("Select Video Platform")}</Label>
                                                <Input
                                                    type="select"
                                                    name="videoPlatform"
                                                    onChange={(event) => {
                                                        setVideoPlatform(event.target.value);
                                                        validation.setFieldValue('videoPlatform', event.target.value);
                                                    }}
                                                    value={videoPlatform}
                                                >
                                                    <option value="YouTube">{t("YouTube")}</option>
                                                    <option value="Vimeo">{t("Vimeo")}</option>
                                                </Input>
                                            </div>
                                        )}
                                              </Col>

                                              <Col>
                                                    <div className="mb-3">
                                                        <Label className="form-label">{t("Set Difficulty Level")}</Label>
                                                        <Input
                                                        type="select"
                                                        name="difficulty_level"
                                                        onChange={handleDiff}
                                                        value={difficulty}
                                                        // invalid={validation.touched.difficulty_level && validation.errors.difficulty_level}
                                                        >
                                                        <option value="">{t("Select difficulty")}</option>
                                                        <option value="easy">{t("Easy")}</option>
                                                        <option value="medium">{t("Medium")}</option>
                                                        <option value="hard">{t("Hard")}</option>
                                                        </Input>
                                                        {/* {validation.touched.difficulty_level && validation.errors.difficulty_level && ( */}
                                                        {/* // <FormFeedback type="invalid">{validation.errors.difficulty_level}</FormFeedback> */}
                                                        {/* // )} */}
                                                    </div>
                                                    </Col>
                                            </Row>

                                        <div className="mb-3">
                                            <Label className="form-label">{t("Video Link")}</Label>
                                            <Input
                                                type="text"
                                                name="video"
                                                onChange={handleVideoLinkChange}
                                                onBlur={validation.handleBlur}
                                                value={videoLink}
                                                invalid={validation.touched.video && validation.errors.video}
                                            />
                                            {validation.touched.video && validation.errors.video && (
                                                <FormFeedback type="invalid">{validation.errors.video}</FormFeedback>
                                            )}
                                            {videoLink && (
                                                <div className="mt-3">
                                                    <iframe
                                                        width="100%"
                                                        height="315"
                                                        src={getVideoEmbedUrl(videoPlatform, videoLink)}
                                                        frameBorder="0"
                                                        allowFullScreen
                                                        title="Video Preview"
                                                    ></iframe>
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex flex-wrap gap-2">
                                            <Button type="submit" color="primary" disabled={isLoading || isLoadingdel}>
                                                {isLoading ? <Spinner size="sm" color="light" /> : t("Submit")}
                                            </Button>
                                            <Button type="button" color="danger" onClick={() => setIsAlertModal(true)} disabled={isLoading || isLoadingdel}>
                                                {isLoadingdel ? <Spinner size="sm" color="light" /> : t("Delete")}
                                            </Button>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default EditVideos;